export function distinctSourceReferences(references: (string | null | undefined)[]): string[] {
    return [...new Set(references.map(reference => reference?.trim()).filter((reference): reference is string => !!reference))].sort();
}
